// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingInfoFormStyles } from "@steiner/App/Components/CustomCreateAccount/ShippingInfoForm";
import { css } from "styled-components";

shippingInfoFormStyles.container = {
    gap: 20,
};

shippingInfoFormStyles.fullGridItem = {
    width: 12,
};

shippingInfoFormStyles.buttonsWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
    `,
};
